import { Container } from "pixi.js";
import { MarketplaceNewsItemView } from "./MarketplaceNewsItemView";
import { MarketplaceNewsItem } from "../../models/news/MarketplaceNewsItem";

export class MarketplaceNewsLine extends Container {
    private readonly itemsCount: number = 3;
    private readonly hideOffset: number = 80;
    private readonly item1: MarketplaceNewsItemView;
    private readonly item2: MarketplaceNewsItemView;
    private readonly item3: MarketplaceNewsItemView;
    private readonly originalTransformCb: (this: any) => any
    private itemsData: Array<MarketplaceNewsItem>;
    private dataPointer: number;

    public constructor() {
        super();
        this.item1 = new MarketplaceNewsItemView();
        this.item2 = new MarketplaceNewsItemView();
        this.item3 = new MarketplaceNewsItemView();
        this.addChild(this.item1, this.item2, this.item3);
        this.dataPointer = 0;
        this.originalTransformCb = this.transform.position.cb.bind(this.transform.position.scope);
        this.transform.position = this.transform.position.clone(this.monitorMovement, this);
    }

    private monitorMovement(): void {
        this.originalTransformCb();
        if (this.itemsData == null || this.itemsData.length === 0) {
            return;
        }
        const firstItemPosition = this.position.x + this.item1.position.x;
        if (firstItemPosition < -(this.item1.width + this.hideOffset)) {
            this.dataPointer++;
            const item1Index = (this.dataPointer * this.itemsCount) % this.itemsData.length;
            this.item1.setData(this.itemsData[item1Index]);
            this.item1.position.x = this.item3.position.x + this.item3.width;
        }

        const secondItemPosition = this.position.x + this.item2.position.x;
        if (secondItemPosition <= -(this.item2.width + this.hideOffset)) {
            const item2Index = (this.dataPointer * this.itemsCount + 1) % this.itemsData.length;
            this.item2.setData(this.itemsData[item2Index]);
            this.item2.position.x = this.item1.position.x + this.item1.width;
        }

        const thirdItemPosition = this.position.x + this.item3.position.x;
        if (thirdItemPosition <= -(this.item3.width + this.hideOffset)) {
            const item3Index = (this.dataPointer * this.itemsCount + 2) % this.itemsData.length;
            this.item3.setData(this.itemsData[item3Index]);
            this.item3.position.x = this.item2.position.x + this.item2.width;
        }
    }

    public setData(itemsData: Array<MarketplaceNewsItem>): void {
        if (itemsData.length < 3) {
            this.item1.clear();
            this.item2.clear();
            this.item3.clear();
            return;
        }
        this.itemsData = itemsData;
        this.dataPointer = 0;
        this.item1.setData(this.itemsData[0]);
        this.item2.setData(this.itemsData[1]);
        this.item3.setData(this.itemsData[2]);
        this.item1.position.x = 0;
        this.item2.position.x = this.item1.position.x + this.item1.width;
        this.item3.position.x = this.item2.position.x + this.item2.width;
    }
}